import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SocketService } from '@frontend/common/util';
import { merge, Observable, race, throwError } from 'rxjs';
import { catchError, filter, first, ignoreElements, mergeMap } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
import { Department } from '../department/department.model';

@Injectable({
  providedIn: 'root',
})
export class DepartmentApiService {
  constructor(private http: HttpClient, private socketSrv: SocketService) {}

  public create(entity: Department) {
    const correlation_id = entity.id;
    return merge(
      this.http.post(`departments`, { ...entity, correlation_id }).pipe(ignoreElements()),
      race(
        this.socketSrv
          .fromLocalSuccess<any>('departments.create')
          .pipe(filter((ws) => ws.correlation_id === correlation_id)),
        this.socketSrv.fromLocalError('departments.create').pipe(
          filter((ws) => ws.correlation_id === correlation_id),
          mergeMap((ws) => throwError(ws))
        )
      ).pipe(first())
    ).pipe(catchError(({ message }) => throwError({ id: entity.id, message })));
  }

  public delete(id) {
    const correlation_id = 'correlation|' + uuid();
    return merge(
      this.http
        .request('delete', `departments/${id}`, { body: { correlation_id } })
        .pipe(ignoreElements()),
      race(
        this.socketSrv
          .fromLocalSuccess<any>('departments.remove')
          .pipe(filter((ws) => ws.correlation_id === correlation_id)),
        this.socketSrv.fromLocalError('departments.remove').pipe(
          filter((ws) => ws.correlation_id === correlation_id),
          mergeMap((ws) => throwError(ws))
        )
      ).pipe(first())
    ).pipe(catchError(({ message }) => throwError({ id, message })));
  }

  public get(params?: { [key: string]: string | string[] }): Observable<Department[]> {
    return this.http.get<Department[]>(`departments`, { params });
  }

  public getOne(id) {
    return this.http.get<Department>(`departments/${id}`);
  }

  public update(entity) {
    const correlation_id = 'correlation|' + uuid();
    return merge(
      this.http
        .put(`departments/${entity.id}`, { ...entity, correlation_id })
        .pipe(ignoreElements()),
      race(
        this.socketSrv
          .fromLocalSuccess<any>('departments.update')
          .pipe(filter((ws) => ws.correlation_id === correlation_id)),
        this.socketSrv.fromLocalError('departments.update').pipe(
          filter((ws) => ws.correlation_id === correlation_id),
          mergeMap((ws) => throwError(ws))
        )
      ).pipe(first())
    ).pipe(catchError(({ message }) => throwError({ id: entity.id, message })));
  }
}
